export const ROOT_CONTAINER_WIDGET_ID = "0";
export const ROOT_CONTAINER_WIDGET_NAME = "MainContainer";
